<template>
  <div class="dem-edi-cab-tab">
    <table :data-time="time" :class="'dem--' + cpntDemanda">
      <!-- SETA O STATUS DA PAGINA -->
      <tr v-if="statusGeral !== ''">
        <td>
          <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5' style="line-height: 100px;"></RF-Status>
        </td>
      </tr>
      
      <!-- SETA OS DADOS DA PAGINA -->
      <template v-else>
        <tr class="noselect dem-edi-cab">
          <!-- VOLTAR -->
          <td class="passadores" v-if="cpntCampos.indexOf('passador') !== -1" rowspan="2" @click="demEditarCabTrocarVenda('voltar')">
            <svg class='fas fa-chevron-left'></svg>
          </td>

          <!-- NUMERO -->
          <td class="titulo numeracao" v-if="cpntCampos.indexOf('numeracao') !== -1">
            <div>
              <!-- SETA O TITULO DA TELA -->
              <span v-html="demEditarCabConverterDemanda"></span>

              <!-- EXCLUIR -->
              <span class="botoes" v-if="cpntCampos.indexOf('editar') !== -1 && cpntFinStatus !== 's' && ([ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(cpntPDocTp) !== -1 || (cpntPDocNFEmitida === false && cpntSDocNFEmitida === false))">
                <button @click="demEditarCabRemoverInfo('dem', true)" class="btn btn-danger btn-sm" :title="demEditarCabTitleExcluirDemanda()">
                  <svg class="fa fa-trash"></svg>
                </button>
              </span>
            </div>
          </td>

          <!-- VENCIMENTO -->
          <td class="titulo data" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1 && cpntCampos.indexOf('vencimento') !== -1">
            <div>
              <span>Data</span>
            </div>
          </td>

          <!-- DADOS REFERENCIA -->
          <td class="titulo dev_ref_nf" v-if="[ '', null, undefined ].indexOf(cpntPDocDocs) === -1 && [ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1 && cpntCampos.indexOf('dev_ref_nf') !== -1">
            <div>
              <span>Nota Referenciada</span>
            </div>
          </td>

          <!-- STATUS -->
          <td class="titulo status" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1 && cpntCampos.indexOf('status') !== -1">
            <div>
              <span>Status</span>
            </div>
          </td>

          <!-- ALIAS -->
          <td class="titulo alias" v-if="[ 'dev_cliente', 'dev_fornecedor', 'compra' ].indexOf(cpntDemanda) === -1 && cpntCampos.indexOf('alias') !== -1 && [ '', null, undefined ].indexOf($store.state.licenca.j_alias) === -1">
            <div>
              <span>Empresa</span>
            </div>
          </td>

          <!-- CONTATO -->
          <td class="titulo contato" v-if="cpntCampos.indexOf('contato') !== -1">
            <div :key="'con-titulo-' + cpntIdCon">
              <span v-if="cpntDemanda === 'venda'">Cliente</span>
              <span v-else-if="cpntDemanda === 'compra'">Fornecedor</span>
              <span v-else>Contato</span>

              <span class="botoes">
                <!-- HISTORICO -->
                <button v-if="[ '', null, undefined, '0', '1', '2' ].indexOf(cpntIdCon) === -1" @click="demEditarCabAbrirHistorico('con')" class="btn btn-default btn-sm" title="Clique aqui para ver o histórico deste contato.">
                  <svg class="fas fa-chart-line"></svg>
                </button>

                <template v-if="cpntCampos.indexOf('editar') !== -1 && cpntFinStatus !== 's' && (cpntPDocNFEmitida === false && cpntSDocNFEmitida === false)">
                  <!-- EDITAR -->
                  <button v-if="[ '', null, undefined, '0', '1', '2' ].indexOf(cpntIdCon) === -1" @click="demEditarCabAbrirCartao('con', true)" class="btn btn-warning btn-sm" title="Clique aqui para editar este contato.">
                    <svg class="fa fa-pencil-alt"></svg>
                  </button>
  
                  <!-- TROCAR -->
                  <button v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1" @click="demEditarCabTrocarInfo('con')" class="btn btn-warning btn-sm" title="Clique aqui para trocar o contato desta venda.">
                    <svg class="fas fa-exchange-alt"></svg>
                  </button>
                </template>
              </span>
            </div>
          </td>

          <!-- VEICULO -->
          <td class="titulo veiculo" v-if="cpntCampos.indexOf('veiculo') !== -1 && pacoteVeiculo === true && cpntDemanda === 'venda'">
            <div :key="'vei-titulo-' + cpntIdVei">
              <span>Veículo</span>

              <span class="botoes">
                <!-- HISTORICO -->
                <button v-if="demEditarCabEditarVeiculo === true" @click="demEditarCabAbrirHistorico('vei')" class="btn btn-default btn-sm" title="Clique aqui para ver o histórico deste veículo.">
                  <svg class="fas fa-chart-line"></svg>
                </button>

                <template v-if="cpntCampos.indexOf('editar') !== -1 && cpntFinStatus !== 's' && (cpntPDocNFEmitida === false && cpntSDocNFEmitida === false)">
                  <!-- EDITAR -->
                  <button v-if="demEditarCabEditarVeiculo === true" @click="demEditarCabAbrirCartao('vei', true)" class="btn btn-warning btn-sm" title="Clique aqui para editar este veículo.">
                    <svg class="fa fa-pencil-alt"></svg>
                  </button>

                  <!-- TROCAR -->
                  <button @click="demEditarCabTrocarInfo('vei')" class="btn btn-warning btn-sm" title="Clique aqui para trocar o veículo desta venda.">
                    <svg class="fas fa-exchange-alt"></svg>
                  </button>

                  <!-- EXCLUIR -->
                  <button v-if="demEditarCabEditarVeiculo === true" @click="demEditarCabRemoverInfo('vei', true)" class="btn btn-danger btn-sm" title="Clique aqui para remover o veículo desta venda.">
                    <svg class="fa fa-trash"></svg>
                  </button>
                </template>
              </span>
            </div>
          </td>

          <!-- PET -->
          <td class="titulo pet" v-if="cpntCampos.indexOf('pet') !== -1 && pacotePet === true && cpntDemanda === 'venda'">
            <div :key="'pet-titulo-' + cpntIdPet">
              <span>Pet</span>

              <span class="botoes">
                <!-- HISTORICO -->
                <button v-if="demEditarCabEditarPet === true" @click="demEditarCabAbrirHistorico('pet')" class="btn btn-default btn-sm" title="Clique aqui para ver o histórico deste pet.">
                  <svg class="fas fa-chart-line"></svg>
                </button>

                <template v-if="cpntCampos.indexOf('editar') !== -1 && cpntFinStatus !== 's' && (cpntPDocNFEmitida === false && cpntSDocNFEmitida === false)">
                  <!-- EDITAR -->
                  <button v-if="demEditarCabEditarPet === true" @click="demEditarCabAbrirCartao('pet', true)" class="btn btn-warning btn-sm" title="Clique aqui para editar este pet.">
                    <svg class="fa fa-pencil-alt"></svg>
                  </button>

                  <!-- TROCAR -->
                  <button @click="demEditarCabTrocarInfo('pet')" class="btn btn-warning btn-sm" title="Clique aqui para trocar o pet desta venda.">
                    <svg class="fas fa-exchange-alt"></svg>
                  </button>

                  <!-- EXCLUIR -->
                  <button v-if="demEditarCabEditarPet === true" @click="demEditarCabRemoverInfo('pet', true)" class="btn btn-danger btn-sm" title="Clique aqui para remover o pet desta venda.">
                    <svg class="fa fa-trash"></svg>
                  </button>
                </template>
              </span>
            </div>
          </td>

          <!-- CONTATO CRÉDITO -->
          <td class="titulo contato" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1 && cpntCampos.indexOf('credito') !== -1">
            <div :key="'con-titulo-' + cpntIdCon">
              <span>Crédito gerado para:</span>

              <span class="botoes" v-if="cpntCampos.indexOf('editar') !== -1 && cpntFinStatus !== 's' && (cpntPDocNFEmitida === false && cpntSDocNFEmitida === false)">
                <button @click="demEditarCabTrocarInfo('con')" class="btn btn-warning btn-sm" title="Clique aqui para trocar o contato crédito desta devolução.">
                  <svg class="fas fa-exchange-alt"></svg>
                </button>
              </span>
            </div>
          </td>

          <!-- ESTOQUE -->
          <td class="titulo estoque" v-if="cpntCampos.indexOf('estoque') !== -1 && [ '', null, undefined ].indexOf(cpntPDocEstoque) === -1">
            <div>
              <span>Estoque</span>
            </div>
          </td>

          <!-- FINANCEIRO -->
          <td class="titulo" v-if="cpntCampos.indexOf('financeiro') !== -1 && cpntPDV === false && cpntFinStatus !== 's' && [ '', null, undefined, 0 ].indexOf(cpntFinAviso) === -1">
            <div>
              <span>Aviso Financeiro</span>
            </div>
          </td>

          <!-- VALORES -->
          <td class="titulo valores" v-if="cpntCampos.indexOf('valores') !== -1 && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
            <div>
              <span>Valor Líquido</span>
              <span v-if="[ 'venda' ].indexOf(cpntDemanda) !== -1 && [ 'orcamento' ].indexOf(cpntDemStatus) !== -1">
                &nbsp;&nbsp;
                <App-Button :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { demVendaOrcamentoValoresAtualizar() }" title="Clique aqui para atualizar os valores de todos os itens deste orçamento.">
                  <svg class="fas fa-redo-alt"></svg>
                </App-Button>                
              </span>
            </div>
          </td>

          <!-- PROXIMA -->
          <td class="passadores" rowspan="2" @click="demEditarCabTrocarVenda('proxima')" v-if="cpntCampos.indexOf('passador') !== -1">
            <svg class='fas fa-chevron-right'></svg>
          </td>
        </tr>

        <tr class="dem-edi-cab">
          <!-- NUMERO -->
          <td class="conteudo numeracao" v-if="cpntCampos.indexOf('numeracao') !== -1">
            <div class="numero">
              <!-- SETA O CODIGO DO REGISTRO -->
              <span v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1" class="link" v-html="demEditarCabFormatarCodigo(cpntDemandaId)" @click="demEditarCabAbrirRecibo(cpntDemanda, cpntDemandaId)"></span>
              <span v-else v-html="demEditarCabFormatarCodigo(cpntDemandaId)"></span>

              <!-- SETA A EXPLICAÇÃO -->
              <App-Explica :cpntTitle='"Número do registro e Data/Hora que foi gerado no sistema."'></App-Explica>
            </div>
            
            <!-- SETA OS DADOS DE DATA E HORA -->
            <div class="data">
              <span v-html="cpntCreatedAt"></span>
            </div>
            
            <div class="dem_ref" v-if="[ '', null, undefined ].indexOf(cpntDemandaRefId) === -1" :title="(cpntDemanda === 'dev_cliente' ? 'Referente a Venda nº ' : 'Referente a Compra nº ') + cpntDemandaRefId">
              Ref. <span class="link" v-html="demEditarCabFormatarCodigo(cpntDemandaRefId, cpntDemanda)" @click="demEditarCabAbrirRecibo('dev' ,cpntDemandaRefId)"></span>
            </div>
          </td>
          
          <!-- VENCIMENTO -->
          <td class="conteudo data" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1 && cpntCampos.indexOf('vencimento') !== -1">
            <b v-if="demEditarCabEditarData === false || cpntCampos.indexOf('editar') === -1" v-html="campos.dem_data.value"></b>
            <App-Calendario v-else :data-time="time" class="app-cpnt-field"
              :cpntStatus='campos.dem_data.status'
              :cpntId='campos.dem_data.id'
              :cpntClassDivField='campos.dem_data.classDivField'
              :cpntNome='campos.dem_data.nome'
              :cpntValue='campos.dem_data.value'
              :cpntAutoComplete='campos.dem_data.autocomplete'
              :cpntMask='campos.dem_data.mask'
              :cpntDisabled='campos.dem_data.disabled'
              :cpntMostrar='campos.dem_data.mostrar'
              :cpntAutoFocus='campos.dem_data.autofocus'
              :cpntMensagem='campos.dem_data.mensagem'
              :cpntMensagemTipo='campos.dem_data.mensagemTipo'
              :cpntPlaceholder='campos.dem_data.placeholder'
              :cpntTabIndex='campos.dem_data.tabIndex'
              :cpntPosicionar='campos.dem_data.posicionar'
              :cpntOnChange='campos.dem_data.onChange'
            ></App-Calendario>
          </td>

          <!-- CONTATO -->
          <td class="conteudo dev_ref_nf" v-if="[ '', null, undefined ].indexOf(cpntPDocDocs) === -1 && [ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1 && cpntCampos.indexOf('dev_ref_nf') !== -1">
            <div>
              <App-Button :cpntClass="'btn btn-default btn-sm'" @onClick="() => { demEditarCabOnAbrirDocumentoFiscal('abrir') }">
              DANFE
              </App-Button>
              <App-Button :cpntClass="'btn btn-default btn-sm'" @onClick="() => { demEditarCabOnAbrirDocumentoFiscal('xml') }">
              XML
              </App-Button>
            </div>
          </td>

          <!-- STATUS -->
          <td class="conteudo status" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1 && cpntCampos.indexOf('status') !== -1">
            <b v-if="demEditarCabEditarStatus === false || cpntCampos.indexOf('editar') === -1" v-html="demEditarCabConverterDemanda"></b>
            <App-Select v-else :data-time="time" class="app-cpnt-field"
              :cpntStatus='campos.dem_status.status'
              :cpntId='campos.dem_status.id'
              :cpntNome='campos.dem_status.nome'
              :cpntValue='campos.dem_status.value'
              :cpntOptions='campos.dem_status.options'
              :cpntKeyValue='campos.dem_status.keyValue'
              :cpntKeyMostra='campos.dem_status.keyMostra'
              :cpntAutoComplete='campos.dem_status.autocomplete'
              :cpntDisabled='campos.dem_status.disabled'
              :cpntMostrar='campos.dem_status.mostrar'
              :cpntMensagem='campos.dem_status.mensagem'
              :cpntSelecioneNome='campos.dem_status.selecioneNome'
              :cpntSelecioneValue='campos.dem_status.selecioneValue'
              :cpntMensagemTipo='campos.dem_status.mensagemTipo'
              :cpntAdicinarOption='campos.dem_status.adicinarOption'
              :cpntMultiple='campos.dem_status.multiple'
              :cpntSearchMinimo='campos.dem_status.searchMinimo'
              :cpntTabIndex='campos.dem_status.tabIndex'

              :cpntOnChange='campos.dem_status.onChange'
              :cpntOnKeyPressEnter='campos.dem_status.onKeyPressEnter'
              :cpntOnFieldBlur='campos.dem_status.onBlur'
            ></App-Select>
          </td>

          <!-- ALIAS -->
          <td class="conteudo status" v-if="[ 'dev_cliente', 'dev_fornecedor', 'compra' ].indexOf(cpntDemanda) === -1 && cpntCampos.indexOf('alias') !== -1 && [ '', null, undefined ].indexOf($store.state.licenca.j_alias) === -1">
            <App-Select :data-time="time" class="app-cpnt-field"
              :cpntStatus='campos.id_alias.status'
              :cpntId='campos.id_alias.id'
              :cpntNome='campos.id_alias.nome'
              :cpntValue='campos.id_alias.value'
              :cpntOptions='campos.id_alias.options'
              :cpntKeyValue='campos.id_alias.keyValue'
              :cpntKeyMostra='campos.id_alias.keyMostra'
              :cpntAutoComplete='campos.id_alias.autocomplete'
              :cpntDisabled='campos.id_alias.disabled'
              :cpntMostrar='campos.id_alias.mostrar'
              :cpntMensagem='campos.id_alias.mensagem'
              :cpntSelecioneNome='campos.id_alias.selecioneNome'
              :cpntSelecioneValue='campos.id_alias.selecioneValue'
              :cpntMensagemTipo='campos.id_alias.mensagemTipo'
              :cpntAdicinarOption='campos.id_alias.adicinarOption'
              :cpntMultiple='campos.id_alias.multiple'
              :cpntSearchMinimo='campos.id_alias.searchMinimo'
              :cpntTabIndex='campos.id_alias.tabIndex'

              :cpntOnChange='campos.id_alias.onChange'
              :cpntOnKeyPressEnter='campos.id_alias.onKeyPressEnter'
              :cpntOnFieldBlur='campos.id_alias.onBlur'
            ></App-Select>
          </td>

          <!-- CONTATO -->
          <td class="conteudo contato" v-if="cpntCampos.indexOf('contato') !== -1" @click="demEditarCabAbrirCartao('con', false)" :key="'con-conteudo-' + cpntIdCon">
            <div>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="cpntIdConNome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='cpntIdConPessoa === "j" && cpntIdConEmpresa !== ""' v-html="' (' + cpntIdConEmpresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='cpntIdConStatus !== "1"' v-html="'[Excluído]'"></b>
            </div>
          </td>

          <!-- VEICULO -->
          <td class="conteudo" v-if="cpntCampos.indexOf('veiculo') !== -1 && pacoteVeiculo === true && cpntDemanda === 'venda'" :class="demEditarCabEditarVeiculo === true ? 'veiculo' : ''" @click="demEditarCabAbrirCartao('vei', false)">
            <template v-if="demEditarCabEditarVeiculo === true">
              <!-- COLOCA NOME DO MODELO -->
              <div><span v-html="cpntIdVeiIdModNome"></span> </div>

              <div>
                <!-- COLOCA O NOME DO VEICULO -->
                <span v-html="cpntIdVeiPlaca"></span>

                <!-- VERIFICA SE O VEICULO ESTA EXCLUIDO -->
                <b v-if='cpntIdVeiStatus !== "1"' v-html="'[Excluído]'"></b>
              </div>
            </template>
            <template v-else>
              ---
            </template>
          </td>

          <!-- PET -->
          <td class="conteudo" v-if="cpntCampos.indexOf('pet') !== -1 && pacotePet === true && cpntDemanda === 'venda'" :class="demEditarCabEditarPet === true ? 'pet' : ''" @click="demEditarCabAbrirCartao('pet', false)">
            <template v-if="demEditarCabEditarPet === true">
              <div>
                <span v-html="cpntIdPetSubespecieNome"></span>
              </div>

              <div>
                <!-- COLOCA O NOME DO PET -->
                <span v-html="cpntIdPetNome"></span>

                <!-- VERIFICA SE O PET ESTA EXCLUIDO -->
                <b v-if='cpntIdPetStatus !== "1"' v-html="'[Excluído]'"></b>
              </div>
            </template>
            <template v-else>
              ---
            </template>
          </td>

          <!-- CONTATO -->
          <td class="conteudo contato" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1 && cpntCampos.indexOf('credito') !== -1" @click="demEditarCabAbrirCartao('con', false)" :key="'con-cre-conteudo-' + cpntContatoCreditoIdCon">
            <div>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="cpntContatoCreditoIdConNome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='cpntContatoCreditoIdConPessoa === "j" && cpntContatoCreditoIdConEmpresa !== ""' v-html="' (' + cpntContatoCreditoIdConEmpresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='cpntContatoCreditoIdConStatus !== "1"' v-html="'[Excluído]'"></b>
            </div>
          </td>

          <!-- ESTOQUE -->
          <td class="conteudo estoque" v-if="cpntCampos.indexOf('estoque') !== -1 && [ '', null, undefined ].indexOf(cpntPDocEstoque) === -1">
            <template v-if="cpntPDocEstoque === 'OK'">
              <App-Icone :data-time='time' :cpntTipo='"check-verde"'></App-Icone>
            </template>
            <template v-else>
              <App-Icone :data-time='time' :cpntTipo='"erro-vermelho"' :cpntExplica="{ mensagem: cpntPDocEstoque.join('<br/><br/>'), posicaoMy: 'top right', posicaoAt: 'bottom left' }"></App-Icone>
            </template>
          </td>

          <!-- FIANNCEIRO -->
          <td class="conteudo financeiro" v-if="cpntCampos.indexOf('financeiro') !== -1 && cpntPDV === false && cpntFinStatus !== 's' && [ '', null, undefined, 0 ].indexOf(cpntFinAviso) === -1">
            Cliente possui <span v-html="cpntFinAviso" @click="demEditarCabAbrirRelatorioFinanceiro"></span> registro(s) com status<br/>A Pagar.
          </td>

          <!-- VALORES -->
          <td class="conteudo valores" v-if="cpntCampos.indexOf('valores') !== -1 && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
            <!-- MOSTRA O VALOR LIQUIDO DA VENDA -->
            <span class="valor" v-html='"R$ " + cpntDemandaTotal.geral._liquido'></span>
            
            <!-- APRESENTA O BOTÃO PARA MOSTRAR E OCULTAR VALORES -->
            <!-- <button class="btn btn-default btn-sm" :key="'valor-icone-' + mostrarValor" @click="mostrarValor = !mostrarValor">
              <svg class="fa fa-plus" v-if="mostrarValor === false"></svg>
              <svg class="fa fa-minus" v-else></svg>
            </button> -->
            <App-Button :cpntClass="'btn btn-default btn-sm'" :cpntStatus="mostrarValor === 'carregando' ? mostrarValor : ''" :key="'valor-icone-' + mostrarValor" @onClick="demEditarCabMostrarDetalheValor">
              <svg class="fa fa-plus" v-if="mostrarValor === false"></svg>
              <svg class="fa fa-minus" v-else></svg>
            </App-Button>

            <div class="detalhes" v-if="mostrarValor === true">
              <table>
                <tr>
                  <td>
                    Total Bruto: 
                  </td>
                  <td>
                    R$ {{ cpntDemandaTotal.geral._total }}
                  </td>
                </tr>
                <tr v-if='[ "", null, undefined ].indexOf(cpntDemandaTotal.servico) === -1 && [ "", null, undefined, "0,00" ].indexOf(cpntDemandaTotal.servico._taxa) === -1'>
                  <td>
                    Taxa Serviço: 
                  </td>
                  <td>
                    <span>R$ {{ cpntDemandaTotal.servico._taxa }}</span>
                  </td>
                </tr>
                <tr v-if='[ "", null, undefined, "0,00" ].indexOf(cpntDemandaTotal.geral._creDevolucao) === -1'>
                  <td>
                    Crédito: 
                  </td>
                  <td>
                    <span style="color: red;">- R$ {{ cpntDemandaTotal.geral._creDevolucao }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    Desconto: 
                  </td>
                  <td>
                    <span style="color: red;">- R$ {{ cpntDemandaTotal.geral._desconto }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    Retenções: 
                  </td>
                  <td>
                    <span style="color: red;">- R$ {{ cpntDemandaTotal.geral._retencao }}</span>
                  </td>
                </tr>
                <tr v-if="[ '', null, undefined ].indexOf(custo) === -1">
                  <td>
                    Custo: 
                  </td>
                  <td>
                    <span style="color: red;">- R$ {{ custo._geral }}</span>
                  </td>
                </tr>
                <tr v-if="[ '', null, undefined ].indexOf(lucro) === -1">
                  <td>
                    Lucro Bruto: 
                  </td>
                  <td>
                    R$ {{ lucro._bruto }}
                  </td>
                </tr>
              </table>


              <!-- <div>
                Custo: R$ {{ custo._geral }}
              </div>
              <div>
                Total Bruto: R$ {{ cpntDemandaTotal.geral._total }}
              </div>
              <div v-if='[ "", null, undefined ].indexOf(cpntDemandaTotal.servico) === -1 && [ "", null, undefined, "0,00" ].indexOf(cpntDemandaTotal.servico._taxa) === -1'>
                Taxa Serviço: <span>R$ {{ cpntDemandaTotal.servico._taxa }}</span>
              </div>
              <div v-if='[ "", null, undefined, "0,00" ].indexOf(cpntDemandaTotal.geral._creDevolucao) === -1'>
                Crédito: <span style="color: red;">- R$ {{ cpntDemandaTotal.geral._creDevolucao }}</span>
              </div>
              <div>
                Desconto: <span style="color: red;">- R$ {{ cpntDemandaTotal.geral._desconto }}</span>
              </div>
              <div>
                Retenções: <span style="color: red;">- R$ {{ cpntDemandaTotal.geral._retencao }}</span>
              </div> -->
            </div>
          </td>
        </tr>
      </template>
    </table>

    <!-- VERIFICA O QUE DEVE SER TROCADO -->
    <Demanda-Editar-Cabecalho-Trocar-Info v-if="[ '', null, undefined ].indexOf(trocar) === -1"
    :cpntContatoId="trocar.contatoId"

    :cpntDemanda="cpntDemanda"
    :cpntDemandaId="cpntDemandaId"
    :cpntTipo="trocar.tipo"
    :cpntFecharFormulario="trocar.callback"
    ></Demanda-Editar-Cabecalho-Trocar-Info>
  </div>
</template>

<style>
.dem-edi-cab-tab {
  width: 100%;
  border-radius: 5px;
  margin: 0px;
  padding: 0px;
  text-decoration: none;
  min-height: 100px;
  border: 1px solid #c6c4c4;
}
  .dem-edi-cab-tab > table {
    width: 100%;
    border-collapse: collapse;
  }
    .dem-edi-cab > td {
      vertical-align: middle;
      background: #fff;
    }
      .dem-edi-cab > td.titulo {
        background: #f7f7f7;
        padding: 0px;
        text-align: center;
        height: 25px;
      }
        .dem-edi-cab > td.titulo > div {
          width: 100%;
          height: 100%;
          padding: 2px 5px;
          border: 1px solid #e6dede;
          border-top: 0px;
        }
        .dem-edi-cab > td.titulo ~ .titulo > div {
          border-left: 0px;
        }
      .dem-edi-cab > td.conteudo {
        text-align: center;
        height: 64px;
        min-height: 64px;
      }
  .dem-edi-cab > td.titulo > div > .botoes {
    float: right;
  }
    .dem-edi-cab > td.titulo > div > .botoes > button {
      margin: 0px 0px 3px 5px;
      padding: 3px 7px;
    }

  .dem-edi-cab > .titulo.numeracao > div {
    border-left: none;
    border-bottom-left-radius: 0px;
  }
  .dem-edi-cab > .titulo.numeracao > div {
    border-bottom-left-radius: 5px;
    border-left: 1px solid #e6dede;
  }
  .dem-edi-cab > .titulo.valores > div {
    border-right: none;
    border-bottom-right-radius: 0px;
  }
  .dem-edi-cab > .titulo.valores > div {
    border-bottom-right-radius: 5px;
    border-right: 1px solid #e6dede;
  }
  .dem-edi-cab > .valores {
    width: 185px;
    min-width: 185px;
    max-width: 185px;
    text-align: center;  
  }
  .dem-edi-cab > .valores > .valor {
    font-weight: bold;
    font-size: 17px;
    line-height: 19px;
    padding: 5px;
  }
  .dem-edi-cab > .valores > button {
    margin: 3px;
    padding: 3px 6px;
  }
  .dem-edi-cab > .valores > .detalhes {
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
  .dem-edi-cab > .valores > .detalhes > table {
    width: 80%;
    margin: 0px auto;
  }
    .dem-edi-cab > .valores > .detalhes > table > tr > td:first-child {
      text-align: left;
    }
    .dem-edi-cab > .valores > .detalhes > table > tr > td:last-child {
      text-align: right;
    }

/* SETA A POSIÇÃO DA COLUNA ESTOQUE */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .estoque {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  text-align: center;
}

/* CONFIGURAÇÃO DO TD COM SETA DE PASSAR OU VOLTAR */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .passadores {
  cursor: pointer;
  text-align: center;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  border: none;
}
  /* CONFIGURAÇÃO DO ICONE DE PASSAR E VOLTAR PAGINA */
  .dem-edi-cab > .passadores > svg {
    font-size: 80px;
    color: #bebebe;
    height: 95px;
    line-height: 95px;
  }
  .dem-edi-cab > .passadores:hover > svg {
    color: #a0a0a0;
  }

/* CONFIGURAÇÃO DO TD DA NUMERCAO */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .numeracao {
  width: 110px;
  min-width: 110px;
  max-width: 145px;
}
  .dem-edi-cab > .numeracao > .numero {
    font-weight: bold;
    font-size: var(--font-base-soma-17);
    line-height: 22px;
  }
    .dem-edi-cab > .numeracao > .numero > img {
      vertical-align: 0px;
    }
      .dem-edi-cab > .numeracao > .dem_ref > .link,
      .dem-edi-cab > .numeracao > .numero > .link {
        cursor: pointer;
      }
      .dem-edi-cab > .numeracao > .dem_ref > .link:hover,
      .dem-edi-cab > .numeracao > .numero > .link:hover {
        text-decoration: underline;
      }

  .dem-edi-cab > .numeracao > .dem_ref,
  .dem-edi-cab > .numeracao > .data {
    width: 60px;
    margin: 0px auto;
    padding-top: 2px;
    font-size: var(--font-base-soma-11);
    line-height: 13px;
  }
  .dem-edi-cab > .numeracao > .dem_ref {
    margin-top: 2px;
  }

.dem--dev_fornecedor > .dem-edi-cab > .numeracao {
  width: 145px;
  min-width: 145px;
  max-width: 145px;
}

/* CONFIGURAÇÃO DO STATUS */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .status {
  width: 136px;
  min-width: 136px;
  max-width: 136px;
}
  .dem-edi-cab > .status > .app-cpnt-field {
    width: 90%;
  }

/* CONFIGURAÇÃO DO data */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .data {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  text-align: center;
}
  .dem-edi-cab > .data > .app-cpnt-field {
    width: 100%;
  }

/* CONFIGURAÇÃO DO REFERENCIA */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
  .dem-edi-cab > .dev_ref_nf {
    text-align: center;
    width: 140px;
  }
    .dem-edi-cab > .dev_ref_nf > div > button {
      width: 90px;
      margin-top: 5px;
    }
    .dem-edi-cab > .dev_ref_nf > div > button:not(:first-child) {
      margin: 5px;
    }

/* CONFIGURAÇÃO DOS LINKS PARA CARTÕES */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .conteudo.contato,
.dem-edi-cab > .conteudo.veiculo,
.dem-edi-cab > .conteudo.pet {
  cursor: pointer;
}
  .dem-edi-cab > .conteudo.contato > div,
  .dem-edi-cab > .conteudo.veiculo > div,
  .dem-edi-cab > .conteudo.pet > div {
    line-height: 23px;
  }

.dem-edi-cab > .conteudo.contato:hover,
.dem-edi-cab > .conteudo.veiculo:hover,
.dem-edi-cab > .conteudo.pet:hover {
  background: #f5f5f5;
  text-decoration: underline;
}

/* CONFIGURAÇÃO DO LINK FINANCEIRO */
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
.dem-edi-cab > .conteudo.financeiro {
  color: red;
  font-size: 12px;
}
  .dem-edi-cab > .conteudo.financeiro > span {
    color: #333;
  }
  .dem-edi-cab > .conteudo.financeiro > span:hover {
    cursor: pointer;
    text-decoration: underline;
  }
</style>

<style>
.dem-edi-cab > .valores > button > svg {
  font-size: 12px;
}
.dem-edi-cab > .data > .app-cpnt-field > input {
  text-align: center;
}
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntCampos: {
        required: false,
        default: function () {
          return [ 'passador', 'numeracao', 'vencimento', 'status', 'alias', 'contato', 'veiculo', 'pet', 'credito', 'estoque', 'whatsapp', 'financeiro', 'valores', 'editar' ]
        }
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaRefId: {
        required: false
      },
      cpntDemandaTotal: {
        required: false
      },
      cpntPDocEstoque: {
        required: false
      },
      cpntFinAviso: {
        required: false
      },

      cpntPDocDocs: {
        required: false
      },
      cpntPDocTp: {
        required: false
      },
      cpntSDocTp: {
        required: false
      },
      cpntPDocNFEmitida: {
        required: false
      },
      cpntSDocNFEmitida: {
        required: false
      },
      cpntIdCon: {
        required: false
      },
      cpntIdConNome: {
        required: false
      },
      cpntIdConCnpjCpf: {
        required: false
      },
      cpntIdConEmpresa: {
        required: false
      },
      cpntIdConPessoa: {
        required: false
      },
      cpntIdConTpCon: {
        required: false
      },
      cpntIdConStatus: {
        required: false
      },

      cpntIdVei: {
        required: false
      },
      cpntIdVeiIdMod: {
        required: false
      },
      cpntIdVeiIdModNome: {
        required: false
      },
      cpntIdVeiIdMar: {
        required: false
      },
      cpntIdVeiIdMarNome: {
        required: false
      },
      cpntIdVeiPlaca: {
        required: false
      },
      cpntIdVeiStatus: {
        required: false
      },

      cpntIdPet: {
        required: false
      },
      cpntIdPetNome: {
        required: false
      },
      cpntIdPetEspecieNome: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntIdPetSubespecieNome: {
        required: false
      },
      cpntIdPetStatus: {
        required: false
      },

      cpntContatoCreditoIdCon: {
        required: false
      },
      cpntContatoCreditoIdConNome: {
        required: false
      },
      cpntContatoCreditoIdConCnpjCpf: {
        required: false
      },
      cpntContatoCreditoIdConEmpresa: {
        required: false
      },
      cpntContatoCreditoIdConPessoa: {
        required: false
      },
      cpntContatoCreditoIdConStatus: {
        required: false
      },

      cpntDemStatus: {
        required: false
      },
      cpntDemAlias: {
        required: false
      },
      cpntDemData: {
        required: false
      },
      cpntFinStatus: {
        required: false
      },
      cpntPDV: {
        required: false
      },
      cpntCreatedAt: {
        required: false
      }
    },
    components: {
      'Demanda-Editar-Cabecalho-Trocar-Info': () => import('@/components/demanda/Editar/Cabecalho/Demanda-Editar-Cabecalho-Trocar-Info'),

      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        voltar: null,
        proxima: null,
        trocar: null,
        custo: null,
        lucro: null,

        mostrarValor: false,
        pacotePet: false,
        pacoteVeiculo: false,

        campos: {
          dem_data: {
            id: 'dem-edi-cab--dem_data',
            status: '',
            tabIndex: 17010001,
            tipo: 'input',
            posicionar: true,
            apiEnv: 'vencimento',
            value: '',
            onChange: this.demEditarCabOnChange
          },
          dem_status: {
            id: 'dem-edi-cab--dem_status',
            status: '',
            tabIndex: 17010002,
            tipo: 'select2',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            searchMinimo: 10,
            apiEnv: 'status',
            value: '',
            onChange: this.demEditarCabOnChange
          },
          id_alias: {
            id: 'dem-edi-cab--id_alias',
            status: '',
            tabIndex: 17010003,
            apiEnv: 'id_alias',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            value: '',
            onChange: this.demEditarCabOnChange
          },
        }
      }
    },
    mounted: function () {
      this.demEditarCabIniciar()
    },
    methods: {
      demEditarCabIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEditarCabSetarStatusGeral('carregando')

        // VERIFICA SE TEM OS PACOTES PARA APRESENTAR AS OPÇÕES
        this.pacotePet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true
        this.pacoteVeiculo = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = Object.keys(this.campos)

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.demEditarCabSetarValorCampo(chave)

          // SETA O VALOR INICIAL DO CAMPO
          this.campos[chave].valueIni = this.campos[chave].value
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TELA
        this.demEditarCabSetarStatusGeral('')
      },
      demEditarCabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // DESTRAVA A TELA
        this.$emit('DEMANDA_TRAVAR_TELA', false)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEditarCabSetarValorCampo: function (chave) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = []

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'id_alias':
            // SETA O ALIAS QUE DEVE APRESENTAR NO CAMPO
            value = [ '', null, undefined, '0' ].indexOf(this.cpntDemAlias) !== -1 ? '0' : this.cpntDemAlias

            // CRIA OS OPTIONS
            options = [ { id: '0', nome: this.$store.state.licenca.rSocial } ]

            // ADICIONA OS ALIAS RECEBIDOS
            if ([ '', null, undefined ].indexOf(this.$store.state.licenca.j_alias) === -1) {
              for (var indexA in this.$store.state.licenca.j_alias) {
                options.push({ id: this.$store.state.licenca.j_alias[indexA].id.toString(), nome: this.$store.state.licenca.j_alias[indexA].nome })
              }
            }
            break

          case 'dem_data':
            value = this.cpntDemData
            break

          case 'dem_status':
            // SETA O VALOR DO CAMPO
            value = this.cpntDemStatus

            // VERIFICA A OPÇÃO QUE DEVE ADICIONAR NO CAMPO
            switch (this.cpntDemanda) {
              case 'venda':
                options = [
                  { id: 'orcamento', nome: 'Orçamento' },
                  { id: 'venda', nome: 'Venda' }
                ]
                break

              case 'compra':
                options = [
                  { id: 'orcamento', nome: 'Orçamento' },
                  { id: 'compra', nome: 'Compra' }
                ]
                break
            }
            break
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'options', options)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEditarCabBuscarAdjacentes: function (callback = null) {
        var route = ''

        // SETA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            route = '/venda/adjacente/get/' + this.cpntDemandaId.toString()
            break

          case 'compra':
            route = '/demanda/dem-adjacente/get/dem_compra/' + this.cpntDemandaId.toString()
            break

          case 'dev_cliente':
            route = '/demanda/dem-adjacente/get/dem_dev_cliente/' + this.cpntDemandaId.toString()
            break

          case 'dev_fornecedor':
            route = '/demanda/dem-adjacente/get/dem_dev_fornecedor/' + this.cpntDemandaId.toString()
            break
        }

        // FAZ A BUSCA DOS DADOS NA API
        this.$store.state.comunicaAPI(route, 'GET', null, (apiSuccess) => {
          // SETA O NUMERO DA VENDA ANTERIOR
          apiSuccess.data.anterior = [ '', null, undefined ].indexOf(apiSuccess.data.anterior) !== -1 ? null : Number(apiSuccess.data.anterior)

          // SETA O NUMERO DA PROXIMA VENDA
          apiSuccess.data.proxima = [ '', null, undefined ].indexOf(apiSuccess.data.proxima) !== -1 ? null : Number(apiSuccess.data.proxima)

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if (callback !== null && typeof callback === 'function') {
            callback(apiSuccess.data)
          }
        }, this.demEditarCabSetarStatusGeral)
      },
      demEditarCabTrocarVenda: function (passador) {
        this.demEditarCabBuscarAdjacentes((vetor) => {
          // INICIA A VARIAVEL
          var item = ''
          var mensagem = ''

          // VERIFICA QUAL É O CODIGO DA VENDA QUE DEVE SER ABERTO
          switch (passador) {
            case 'voltar':
              item = vetor.anterior
              mensagem = 'Nenhuma ' + (this.demEditarCabConverterDemanda).toLowerCase() + ' anterior encontrada.'
              break

            case 'proxima':
              item = vetor.proxima
              mensagem = 'Nenhuma ' + (this.demEditarCabConverterDemanda).toLowerCase() + ' encontrada para avançar.'
              break
          }

          // REDIRENCIA PARA PAGINA SOLICITADA
          switch (item) {
            case null:
              this.$store.state.msgWarn('WEB [406]: ' + mensagem, 'warning')
              break

            default:
              // SETA O STATUS DA TELA
              this.$emit('DEMANDA_TRAVAR_TELA', true)

              // MANDA ABRIR O REGISTRO SOLICITADO
              this.$router.push({ name: 'demanda_tipo_numero', params: { tipo: this.cpntDemanda, id: item } })
              break
          }
        })
      },
      demEditarCabOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // VERIFICA A AÇÃO QUE DEVE REALIZAR NO CAMPO
        if ([ '' ].indexOf(indexF[1]) === -1) {
          // SETA O VALOR RECEBIDO
          this.$set(this.campos[indexF[1]], 'value', value)
  
          // LIMPA O CAMPO DE MENSAGEM DE ERRO
          this.$set(this.campos[indexF[1]], 'mensagem', '')
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'dem_data':
          case 'dem_status':
          case 'id_alias':
            this.demEditarCabAtualizarCampo(indexF[1])
            break
        }
      },
      // demEditarCabOnBlur: function (id) {
      //   // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
      //   var indexF = id.split('--')[1]
        
      //   // VERIFICA O CAMPO QUE ESTÁ SENDO ALTERADO
      //   switch (indexF) {
      //   }
      // },
      demEditarCabAtualizarCampo: function (indexF = '') {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM ALTERAÇÃO NO CAMPO
        if (this.campos[indexF].value !== this.campos[indexF].valueIni) {
          // TRAVA A TELA
          this.$emit('DEMANDA_TRAVAR_TELA', true)
  
          // INICIA AS VARIAVEIS
          var router = ''
          var formData = {}
  
          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (this.cpntDemanda + '_' + this.campos[indexF].apiEnv) {
            case 'compra_vencimento':
              // SETA A ROTA que EVE CHAMAR
              router = '/demanda/dem-compra/dem-data'

              // SETA A DATA QUE DEVE ATUALIZAR
              formData.dem_data = (typeof this.campos[indexF].value === 'string' ? this.campos[indexF].value : this.campos[indexF].value[this.campos[indexF].keyValue])
              break

            case 'compra_status':
              // SETA A ROTA que EVE CHAMAR
              router = '/demanda/dem-compra/dem-status'

              // SETA A DATA QUE DEVE ATUALIZAR
              formData.dem_status = (typeof this.campos[indexF].value === 'string' ? this.campos[indexF].value : this.campos[indexF].value[this.campos[indexF].keyValue])

              // VERIFICA O NOVO STATUS DA COMPRA A SER SETADO
              formData.dem_status = formData.dem_status === 'compra' ? '2' : '1'
              break

            default:
              // SETA A ROTA que EVE CHAMAR
              router = '/venda'

              // SETA O CAMPO QUE DEVE ATUALIZAR
              formData[this.campos[indexF].apiEnv] = (typeof this.campos[indexF].value === 'string' ? this.campos[indexF].value : this.campos[indexF].value[this.campos[indexF].keyValue])

              // VERIFICA O NOVO STATUS DA VENDA A SER SETADO
              if ([ '', null, undefined ].indexOf(formData.status) === -1) {
                switch (this.cpntDemanda) {
                  case 'venda':
                    formData.status = formData.status === 'venda' ? '2' : '1'
                    break

                  case 'compra':
                    formData.status = formData.status === 'compra' ? '2' : '1'
                    break
                }
              }

              // SETA O VALOR ATUALIZADO
              if ([ '', null, undefined ].indexOf(formData.id_alias) === -1 && formData.id_alias === '0') {
                formData.id_alias = 'null'
              }
              break
          }

          // VERIFICA O FORMULARIO QUE DEVE ENVIAR
          if (router === '/venda') {
            formData.cod_venda = this.cpntDemandaId
          } else {
            // SETA O NUMERO DE REFERENCIA QUE DEVE ENVIAR
            formData.dem_compra = this.cpntDemandaId

            // CONVERTE OS DADOS EM LOT
            formData = { lot: [ formData ] }
          }

  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEditarCabTratarValidacao(retorno.message, retorno.code)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
    
              // DESTRAVA A TELA
              this.$emit('DEMANDA_TRAVAR_TELA', false)
  
              // ATUALIZA OS DADOS E DESTRAVA A TELA
              this.$emit('DEMANDA_BUSCAR_VALORES', () => { setTimeout(() => { this.demEditarCabIniciar() }, 500) })
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }, this.demEditarCabSetarStatusGeral, this.demEditarCabTratarValidacao)
        }
      },
      demEditarCabTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // DESTRAVA A TELA
          this.$emit('DEMANDA_TRAVAR_TELA', false)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demEditarCabAbrirHistorico: function (tipo) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'CONSULTAR_HISTORICO', filtros: {} }

        // VERIFICA A DEMANDA QUE DEVE SELECIONAR
        params.filtros.dem = [ 'dem_compra', 'dem_venda' ]
        params.filtros.dem_sta = [ 'dem_compra__2', 'dem_venda__2' ]

        // SETA O TIPO DE REGISTRO QUE DEVE ABRIR
        switch (tipo) {
          case 'con':
            // VERIFICA A DEMANDA QUE DEVE SELECIONAR
            if ([ '1' ].indexOf(this.cpntIdConTpCon) !== -1) {
              params.filtros.dem = [ 'dem_venda' ]
              params.filtros.dem_sta = [ 'dem_venda__2' ]
            } else if ([ '2' ].indexOf(this.cpntIdConTpCon) !== -1) {
              params.filtros.dem = [ 'dem_compra' ]
              params.filtros.dem_sta = [ 'dem_compra__2' ]
            }
            
          //   // SETA O CONTATO QUE DEVE FILTRAR
          //   params.filtros.con = [ this.cpntIdCon.toString() ]
          //   break

          // case 'vei':
          //   params.filtros.vei = [ this.cpntIdVei.toString() ]
          //   break

          // case 'pet':
          //   params.filtros.pet = [ this.cpntIdPet.toString() ]
            break
        }

        // VERIFICA SE TEM ALGUM CADASTRO PRA FILTAR
        if ([ '', null, undefined, '0' ].indexOf(this.cpntIdCon) === -1) {
          params.filtros.con = [ this.cpntIdCon.toString() ]
        }
        if ([ '', null, undefined, '0' ].indexOf(this.cpntIdVei) === -1) {
          params.filtros.vei = [ this.cpntIdVei.toString() ]
        }
        if ([ '', null, undefined, '0' ].indexOf(this.cpntIdPet) === -1) {
          params.filtros.pet = [ this.cpntIdPet.toString() ]
        }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id) => {
          if (atualizar === true) {
            this.demEditarCabAtualizarDados(params._chave, id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      demEditarCabAbrirCartao: function (tipo, editar = false) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: editar }

        // SETA O TIPO DE REGISTRO QUE DEVE ABRIR
        switch (tipo) {
          case 'con':
            params.id = this.cpntIdCon
            params.tipo = 'contato'
            params._chave = 'id_con'
            break

          case 'vei':
            params.id = this.cpntIdVei
            params.tipo = 'veiculo'
            params._chave = 'id_vei'
            break

          case 'pet':
            params.id = this.cpntIdPet
            params.tipo = 'pet'
            params._chave = 'id_pet'
            break
        }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar, id) => {
            if (atualizar === true) {
              this.demEditarCabAtualizarDados(params._chave, id)
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      demEditarCabAtualizarDados: function (chave, id) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // SETA O STATUS DA TELA
        this.$emit('DEMANDA_TRAVAR_TELA', true)

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // INICIA A VARIAVEL PARA RECEBER A ROTA
        var router = ''

        // INICIA O FORMULARIO
        var formData = {}

        // SETA O ID QUE DEVE ATUALIZAR
        formData[chaveD] = this.cpntDemandaId

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda + '--' + chave) {
          case 'venda--id_con':
            // router = '/demanda/dem-venda/id-con'
            formData.id_con = id
            break
          case 'venda--id_vei':
            // router = '/demanda/dem-venda/id-vei'
            formData.id_vei = id
            break
          case 'venda--id_pet':
            // router = '/demanda/dem-venda/id-pet'
            formData.id_pet = id
            break

          case 'compra--id_con':
            router = '/demanda/dem-compra/id-con'
            formData.id_con = id
            break

          case 'dev_cliente--id_con':
            router = '/demanda/dem-dev-cliente/id-con-dev-credito'
            formData.id_con_dev_credito = id
            break

          case 'dev_fornecedor--id_con':
            router = '/demanda/dem-dev-fornecedor/id-con-dev-credito'
            formData.id_con_dev_credito = id
            break
        }

        // ALTERA PARA PUT DE VENDA GERAL
        if (router === '') {
          router = '/venda'
        } else {
          formData = { lot: [ formData ] }
        }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(router, 'PUT', formData, (apiSuccess) => {
          // PEGA O RETORNO RECEBIDO 
          var retorno = [ '', null, undefined ].indexOf(apiSuccess.lot) === -1 ? apiSuccess.lot[0] : { code: '200', message: apiSuccess.message }

          // VERIFICA O RESULTADO DA OPERAÇÃO
          switch (retorno.code) {
            case '200':
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
    
              // ATUALIZA OS DADOS E DESTRAVA A TELA
              this.$emit('DEMANDA_BUSCAR_VALORES', () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
              break

            default:
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, (campos) => {
                // SETA OS CAMPOS COM OS ERROS
                this.campos = campos

                // ATUALIZA OS DADOS E DESTRAVA A TELA
                this.$emit('DEMANDA_BUSCAR_VALORES', () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
              })
              break
          }
        }, this.demEditarCabSetarStatusGeral, (apiValid, apiStatus) => {
          this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, this.campos, true, (campos) => {
            // SETA OS CAMPOS COM OS ERROS
            this.campos = campos

            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$emit('DEMANDA_BUSCAR_VALORES', () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
          })
        })
      },
      demEditarCabRemoverInfo: function (tipo) {
        // INICIA A MENSAGEM QUE SERÁ APRESENTADO
        var mensagem = ''

        // INICIA O CALLBACK QUE DEVE REALIZAR
        var callback = null

        // SETA O TIPO DE REGISTRO QUE DEVE ABRIR
        switch (tipo) {
          case 'vei':
            // SETA A MENSAGEM
            mensagem = 'Deseja realmente remover o veículo desta venda?'

            // SETA A FUNÇÃO QUE DEVE EXECUTAR SE O CLIENTE CONFIRMAR
            callback = () => { this.demEditarCabAtualizarDados('id_vei', '0') }
            break

          case 'pet':
            // SETA A MENSAGEM
            mensagem = 'Deseja realmente remover o pet desta venda?'

            // SETA A FUNÇÃO QUE DEVE EXECUTAR SE O CLIENTE CONFIRMAR
            callback = () => { this.demEditarCabAtualizarDados('id_pet', '0') }
            break

          case 'dem':
            // SETA A MENSAGEM
            mensagem = 'Deseja realmente excluir esta ' + this.demEditarCabConverterDemanda + '?'

            // SETA A FUNÇÃO QUE DEVE EXECUTAR SE O CLIENTE CONFIRMAR
            callback = () => { this.demEditarCabExcluirDemanda() }
            break
        }

        // SOLICITA A CONFIRMAÇÃO PARA CONTINUAR
        if (mensagem !== '' && confirm(mensagem)) {
          callback()
        }
      },
      demEditarCabExcluirDemanda: function () {
        // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
        var formData = { j_id: JSON.stringify([ this.cpntDemandaId ]) }

        // INICIA A VARIAVEL
        var router = ''
        var page = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            router = '/venda'
            page = 'vendas_gerenciar'
            break

          case 'compra':
            router = '/demanda/dem-compra'
            page = 'compras_gerenciar'
            break
          
          case 'dev_cliente':
            router = '/demanda/dem-dev-cliente'
            page = 'dev_cliente_gerenciar'
            break
          
          case 'dev_fornecedor':
            router = '/demanda/dem-dev-fornecedor'
            page = 'dev_fornecedor_gerenciar'
            break
        }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(router, 'DELETE', formData, (apiSuccess) => {
          // PEGA O RETORNO RECEBIDO 
          var retorno = [ '', null, undefined ].indexOf(apiSuccess.lot) === -1 ? apiSuccess.lot[0] : { code: '200', message: apiSuccess.message }

          // VERIFICA O RESULTADO DA OPERAÇÃO
          switch (retorno.code) {
            case '200':
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

              // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DO MENU
              this.$store.commit('SET_INFO_MENU')
    
              // ATUALIZA OS DADOS E DESTRAVA A TELA
              this.$router.push({ name: page, params: {} })
              break

            default:
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, (campos) => {
                // SETA OS CAMPOS COM OS ERROS
                this.campos = campos

                // SETA O STATUS DA TELA
                this.$emit('DEMANDA_TRAVAR_TELA', false)
              })
              break
          }
        }, this.demEditarCabSetarStatusGeral)
      },
      demEditarCabTrocarInfo: function (tipo) {
        // INICIA O VETOR 
        var vetor = {}
        
        // SETA O TIPO DE REGISTRO QUE DEVE ABRIR
        switch (tipo) {
          case 'con':
            vetor.tipo = 'contato'
            vetor._chave = 'id_con'
            break

          case 'vei':
            vetor.tipo = 'veiculo'
            vetor._chave = 'id_vei'
            break

          case 'pet':
            vetor.tipo = 'pet'
            vetor._chave = 'id_pet'
            break
        }

        // SETA O ID DO CONTATO DA VENDA
        vetor.contatoId = this.cpntIdCon

        // SETA O CALLBACK QUE DEVE EXECUTAR
        vetor.callback = (atualizar, id) => {
          // VERIFICA SE DEVE ATUALIZAR A TELA
          if (atualizar === true) {
            this.demEditarCabAtualizarDados(vetor._chave, id)
          }

          // SETA O VETOR O VALOR DO VETOR
          this.trocar = null
        }

        // SETA O VETOR O VALOR DO VETOR
        this.trocar = vetor
      },
      demEditarCabAbrirRecibo: function (demanda, demandaId) {
        // INICIA O PARAMETRO
        var vetor = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: demanda, id: demandaId, tipo: 'recibo', formato: 'html' } }

        // VERIFICA SE É UMA DEVOLUÇÃO A SER CONVERTIDA
        if (demanda === 'dev') {
          // VERIFICA O PARAMETRO QUE DEVE USAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              demanda = 'venda'
              break

            case 'dev_fornecedor':
              demanda = 'compra'
              break
          }

          // ATUALIZA OS PARAMETROS
          vetor = { name: 'demanda_tipo_numero', params: { tipo: demanda, id: demandaId } }
        }

        // VERIFICA SE DEVE ABRIR OU NÃO O LINK
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(demanda) === -1) {
          this.$store.state.OPEN_PAGE_CS(this.$router.resolve(vetor).href, '_blank', {}, false)
        }
      },
      demEditarCabAbrirRelatorioFinanceiro: function () {
        // SETA OS PARAMETROS DA BUSCA
        var params = {
          pesquisa: '0',
          despesa: [ 'n' ],
          contato: [ this.cpntIdCon ],
          status: [ '1', '4' ],
          periodo: 't'
        }

        // CONVERTE O VALOR EM JSON STRING
        params = window.btoa(JSON.stringify(params))

        // MANDA ABRIR A PAGINA
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'financeiro_relatorio_params', params: { cts: this.$store.state.token.cts, params: params } }).href, '_blank', {}, false)
      },
      demEditarCabEnviarWhatsApp: function () {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'ENVIO', ref_mod: 'venda', ref_id: this.cpntDemandaId }
        
        // // SETA O CALLBACK QUE DEVE EXECUTAR
        // params.callback = (atualizar, id) => {
        //   console.log(atualizar, id)
        // }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      demEditarCabTitleExcluirDemanda: function () {
        switch (this.cpntDemanda) {
          case 'venda':
            return 'Clique aqui para excluir a venda/orçamento.'

          case 'compra':
            return 'Clique aqui para excluir a compra/orçamento.'
        
          case 'dev_cliente':
            return 'Clique aqui para excluir a devolução de cliente'
        
          case 'dev_fornecedor':
            return 'Clique aqui para excluir a devolução de fornecedor'
        }
      },
      demEditarCabFormatarCodigo: function (valor, demanda = null) {
        // PEGA O VALOR RECEBIDO E CONVERTE EM STRING
        valor = valor.toString()

        // FORMATA O VALOR RETORNADO
        valor = (valor.length <= 4 ? ('0000' + valor).slice(-4) : valor)

        // COLOCA A INICIAL DO MODULO
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(demanda) !== -1) {
          valor = (demanda === 'dev_cliente' ? 'V' : 'C') + valor
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      demEditarCabOnAbrirDocumentoFiscal: function (acao) {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'ABRIR_DOC_FISCAL', acao: acao, origem: 'df' }

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (this.cpntDemanda) {
          case 'dev_cliente':
            params.id = this.cpntPDocDocs.toString()
            break

          case 'dev_fornecedor':
            // SETA O ID DA COMPRA
            params.id = this.cpntDemandaRefId.toString()

            // SETA A ORIGEM DA SOLICITAÇÃO
            params.origem = 'compra_dist'
            break
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demVendaOrcamentoValoresAtualizar: function () {

        if (!window.confirm('Deseja realmente atualizar os valores de todos os itens deste orçamento?'))
          return;

        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // TRAVA A TELA
        this.$emit('DEMANDA_TRAVAR_TELA', true)

        // INICIA AS VARIAVEIS
        var router = '/venda/orcamento/val-atualizar'
        var formData = {}

        formData.cod_orcamento = this.cpntDemandaId

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
          // PEGA O VALOR RECEBIDO
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

          // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
          if (retorno.code !== '200') {
            this.demEditarCabTratarValidacao(retorno.message, retorno.code)
          } else {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)
  
            // DESTRAVA A TELA
            this.$emit('DEMANDA_TRAVAR_TELA', false)

            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$emit('DEMANDA_BUSCAR_VALORES', () => { setTimeout(() => { this.demEditarCabIniciar() }, 500) })

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }, this.demEditarCabSetarStatusGeral, this.demEditarCabTratarValidacao)
      },
      demEditarCabMostrarDetalheValor: function () {
        if (this.mostrarValor === true || this.cpntDemanda !== 'venda') {
          // SETA O STATUS CARREGANDO DA PAGINA
          this.mostrarValor = !this.mostrarValor

          // LIMPA O VETOR
          this.custo = null
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          // SETA O STATUS CARREGANDO DA PAGINA
          this.mostrarValor = 'carregando'
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // INICIA A VARIAVEL
          var route = ''
          var queryGet = {}
  
          // SETA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'venda':
              // SETA A ROTA QUE DEVE CHAMAR
              route = '/venda/get'

              // SETA O LIMIT DO REQUEST
              queryGet.limit = { row: 0, qty: 1 }

              // SETA O LIMIT DO REQUEST
              queryGet.type = 'list'

              // SETA O FIELD
              queryGet.field = { cod_venda: null }

              // SETA O FIELD
              queryGet.field_virtual = [ 'total', 'custo', 'lucro' ]

              // SETA O WHERE QUE DEVE REALIZAR
              queryGet.where = { f: 'cod_venda', o: '=', v: this.cpntDemandaId }
              break
          }
  
          // FAZ A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI(route, 'POST', queryGet, (retorno) => {
            // SETA OS VALORES DO CUSTO RECEBIDO
            this.custo = retorno.data[0].virtual_custo
            this.lucro = retorno.data[0].virtual_lucro

            // FORMTA O VALOR RECEBIDO
            this.custo._geral = this.$store.state.FUN_MASK_VALOR('valorMoeda', (Number(this.custo.geral) * 100).toFixed(0))
            this.lucro._bruto = this.$store.state.FUN_MASK_VALOR('valorMoeda', (Number(this.lucro.bruto) * 100).toFixed(0))

            // SETA O STATUS CARREGANDO DA PAGINA
            this.mostrarValor = true
    
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.demEditarCabSetarStatusGeral)
        }
      }
    },
    computed: {
      demEditarCabConverterDemanda: function () {
        switch (this.cpntDemanda) {
          case 'venda':
            return 'Venda'

          case 'compra':
            return 'Compra'

          case 'dev_cliente':
            return 'Dev. Cliente'

          case 'dev_fornecedor':
            return 'Dev. Fornecedor'

          default:
            return '<span style="color: red;">Erro</span>'
        }
      },
      demEditarCabEditarData: function () {
        return this.cpntFinStatus !== 's' && this.cpntPDV === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 17 ], null, [ 10 ], null, [ 124 ], null, false) === true
      },
      demEditarCabEditarStatus: function () {
        switch (this.cpntDemanda) {
          case 'venda':
            return this.cpntFinStatus !== 's' && this.cpntPDV === false && this.cpntPDocTp === '' && this.cpntSDocTp === ''
        
          case 'compra':
            return this.cpntFinStatus !== 's' && this.cpntPDV === false && this.cpntPDocTp === ''
        }
      },
      demEditarCabEditarVeiculo: function () {
        return this.pacoteVeiculo === true && this.cpntDemanda === 'venda' && [ '', null, undefined ].indexOf(this.cpntIdVei) === -1
      },
      demEditarCabEditarPet: function () {
        return this.pacotePet === true && this.cpntDemanda === 'venda' && [ '', null, undefined ].indexOf(this.cpntIdPet) === -1
      }
    },
    watch: {
      cpntDemData: function () {
        this.demEditarCabSetarValorCampo('dem_data')
      },
      cpntDemStatus: function () {
        this.demEditarCabSetarValorCampo('dem_status')
      },
      cpntDemAlias: function () {
        this.demEditarCabSetarValorCampo('id_alias')
      }
    }
  }
</script>
